<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-buttons slot="end">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" aria-label="Close search">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar mode="ios" color="light">
    <ion-searchbar
      [(ngModel)]="searchQuery"
      (ionInput)="onSearchChange($event)"
      [debounce]="250"
      placeholder="Search admin screens, users, reports, or audit events"
      data-testid="admin-global-search-input"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (recentSearches.length > 0 && !searchQuery) {
    <section class="admin-global-search__section">
      <div class="admin-global-search__section-header">
        <h2>Recent searches</h2>
        <ion-button fill="clear" size="small" (click)="clearRecentSearches()">Clear</ion-button>
      </div>
      <ion-list class="admin-global-search__list">
        @for (query of recentSearches; track query) {
          <ion-item button lines="none" class="admin-global-search__item" (click)="selectRecentSearch(query)">
            <ion-icon name="time-outline" slot="start"></ion-icon>
            <ion-label>{{ query }}</ion-label>
          </ion-item>
        }
      </ion-list>
    </section>
  }

  @if (searchQuery && searchResults.length > 0) {
    <ion-list class="admin-global-search__list">
      @for (result of searchResults; track result.id) {
        <ion-item button lines="none" class="admin-global-search__item" (click)="selectResult(result)">
          <ion-icon [name]="result.icon" slot="start"></ion-icon>
          <ion-label>
            <h3>{{ result.title }}</h3>
            <p>{{ result.subtitle }}</p>
          </ion-label>
          @if (result.badge) {
            <ion-badge slot="end" color="medium">{{ result.badge }}</ion-badge>
          }
        </ion-item>
      }
    </ion-list>
  }

  @if (searchQuery && searchResults.length === 0 && !isSearching) {
    <div class="admin-global-search__state">
      <ion-icon name="search-outline"></ion-icon>
      <ion-text color="medium">No admin results found</ion-text>
    </div>
  }

  @if (isSearching) {
    <div class="admin-global-search__state">
      <ion-text color="medium">Searching...</ion-text>
    </div>
  }

  @if (!searchQuery && recentSearches.length === 0) {
    <div class="admin-global-search__state">
      <ion-icon name="search-outline"></ion-icon>
      <ion-text color="medium">Search across admin screens and indexed operations data.</ion-text>
    </div>
  }
</ion-content>
